export default [
    {
        path: '/',
        name: 'login',
        meta: {
            title: '로그인화면',
        },
        component: () => import('@/pages/login/login')
    },
    {
        path: '/rePwd',
        name: 'rePwd',
        meta: {
            title: '비밀번호 재설정',
        },
        component: () => import('@/pages/rePwd/rePwd')
    },
    {
        path: '/schedInfo',
        name: 'schedInfo',
        meta: {
            title: '스케줄',
        },
        component: () => import('@/pages/schduleManage/schedInfo')
    },
    {
        path: '/annualReg',
        name: 'annualReg',
        meta: {
            title: '휴가 신청',
        },
        component: () => import('@/pages/annual/annualReg')
    },
    {
        path: '/annualApl',
        name: 'annualApl',
        meta: {
            title: '휴가 결재',
        },
        component: () => import('@/pages/annual/annualApl')
    },
    {
        path: '/annualAdminAll',
        name: 'annualAdminAll',
        meta: {
            title: '휴가 관리(관리자-전체)',
        },
        component: () => import('@/pages/annual/annualAdminAll')
    },
    {
        path: '/annualAdminDetail',
        name: 'annualAdminDetail',
        meta: {
            title: '휴가 관리(관리자-직원별)',
        },
        component: () => import('@/pages/annual/annualAdminDetail')
    },
    {
        path: '/annualMng',
        name: 'annualMng',
        meta: {
            title: '휴가 관리',
        },
        component: () => import('@/pages/annual/annualMng')
    },
    {
        path: '/addEmp',
        name: 'addEmp',
        meta: {
            title: '직워 추가',
        },
        component: () => import('@/pages/mng/addEmp')
    },
    {
        path: '/addAnnual',
        name: 'addAnnual',
        meta: {
            title: '직워 추가',
        },
        component: () => import('@/pages/mng/addAnnual')
    },
    {
        path: '/test2',
        name: 'test2',
        meta: {
            title: 'test2',
        },
        component: () => import('@/pages/test/test2')
    },
    {
        path: '/test3',
        name: 'test3',
        meta: {
            title: 'test3',
        },
        component: () => import('@/pages/test/test3')
    },
    {
        path: '/test4',
        name: 'test4',
        meta: {
            title: 'test4',
        },
        component: () => import('@/pages/test/test4')
    },
    {
        path: '/test5',
        name: 'test5',
        meta: {
            title: 'test5',
        },
        component: () => import('@/pages/test/test5')
    },
    {
        path: '/test6',
        name: 'test6',
        meta: {
            title: 'test6',
        },
        component: () => import('@/pages/test/test6')
    },
    {
        path: '/settings',
        name: 'settings',
        meta: {
            title: '설정',
        },
        component: () => import('@/pages/settings/settings')
    },
    {
        path: '/notice',
        name: 'noticeList',
        meta: {
            title: '공지사항',
        },
        component: () => import('@/pages/board/notice.vue')
    },
];
